import { FieldOptionInterface, ProviderDto } from '@families-link/shared';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type EngagementFiltersState = {
	search: string;
	languages: string[];
	providers: ProviderDto[];
	schools: FieldOptionInterface[];
	duration: [Date | null, Date | null];
	withReminder?: boolean;
	linkedToFamily?: boolean;
	//mode: 'archived' | 'linguist-link' | 'family-link';
	sortingArray: any[];
};

const initialState: EngagementFiltersState = {
	search: '',
	languages: [],
	providers: [],
	schools: [],
	duration: [null, null],
	withReminder: undefined,
	linkedToFamily: undefined,
	//mode: 'family-link',
	sortingArray: [],
};

export const engagementFiltersSlice = createSlice({
	name: 'engagementFilters',
	initialState,
	reducers: {
		setFilters: (state: EngagementFiltersState, action: PayloadAction<Partial<EngagementFiltersState>>) => ({
			...state,
			...action.payload,
		}),
		resetFilters: (): EngagementFiltersState => initialState,
	},
});

export const { setFilters, resetFilters } = engagementFiltersSlice.actions;

export default engagementFiltersSlice.reducer;
